module.exports = __webpack_public_path__ + "files/d1a344eee3ced2dc1f2404e528c85f3b.png";